module.exports = __webpack_public_path__ + "static/Hero-mla.90fe3086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hero-mla.jpg
// module id = 495
// module chunks = 172546399187757